// src/lib/BaseDatePlugin.ts
import { bindFirst, createSlatePlugin } from "@udecode/plate";

// src/lib/queries/isPointNextToNode.ts
import {
  PathApi
} from "@udecode/plate";
var isPointNextToNode = (editor, options) => {
  let { at, nodeType, reverse = false } = options;
  if (!at) {
    at = editor.selection?.anchor;
  }
  if (!at) {
    throw new Error("No valid selection point found");
  }
  const selectedRange = editor.api.range(at.path);
  const boundary = (() => {
    let isStart = false;
    let isEnd = false;
    if (editor.api.isStart(at, selectedRange)) {
      isStart = true;
    }
    if (editor.api.isEnd(at, selectedRange)) {
      isEnd = true;
    }
    if (isStart && isEnd) {
      return "single";
    }
    if (isStart) {
      return "start";
    }
    if (isEnd) {
      return "end";
    }
    return null;
  })();
  if (!boundary) return false;
  const adjacentPathFn = (path) => {
    try {
      if (reverse && boundary === "start") return PathApi.previous(path);
      if (!reverse && boundary === "end") return PathApi.next(path);
      if (boundary === "single") {
        return reverse ? PathApi.previous(path) : PathApi.next(path);
      }
    } catch {
      return null;
    }
  };
  if (!adjacentPathFn) return false;
  const adjacentPath = adjacentPathFn(at.path);
  if (!adjacentPath) return false;
  const nextNodeEntry = editor.api.node(adjacentPath) ?? null;
  return !!(nextNodeEntry && nextNodeEntry[0].type === nodeType);
};

// src/lib/transforms/insertDate.ts
var insertDate = (editor, { date, ...options } = {}) => {
  editor.tf.insertNodes(
    [
      {
        children: [{ text: "" }],
        date: date ?? (/* @__PURE__ */ new Date()).toDateString(),
        type: editor.getType(BaseDatePlugin)
      },
      // FIXME: for not losing the editor focus
      {
        text: " "
      }
    ],
    options
  );
};

// src/lib/BaseDatePlugin.ts
var BaseDatePlugin = createSlatePlugin({
  key: "date",
  handlers: {},
  node: {
    isElement: true,
    isInline: true,
    isSelectable: false,
    isVoid: true
  }
}).overrideEditor(({ editor, tf: { move }, type }) => ({
  transforms: {
    // check if cursor is next to a date node. if it is set the unit:'offset'
    // Default left/right behavior is unit:'character'.
    // This fails to distinguish between two cursor positions, such as
    // <inline>foo<cursor/></inline> vs <inline>foo</inline><cursor/>.
    // Here we modify the behavior to unit:'offset'.
    // This lets the user step into and out of the inline without stepping over characters.
    // You may wish to customize this further to only use unit:'offset' in specific cases.
    move: (options) => {
      const {
        distance = 1,
        reverse = false,
        unit = "character"
      } = options || {};
      if (unit === "character" && distance === 1 && editor.selection && !editor.api.isExpanded()) {
        const isNextDate = isPointNextToNode(editor, {
          nodeType: type,
          reverse
        });
        if (isNextDate) {
          return move({
            ...options,
            unit: "offset"
          });
        }
      }
      return move(options);
    }
  }
})).extendEditorTransforms(({ editor }) => ({
  insert: {
    date: bindFirst(insertDate, editor)
  }
}));
export {
  BaseDatePlugin,
  insertDate,
  isPointNextToNode
};
//# sourceMappingURL=index.mjs.map